<div class="status-page">
    <div class="wrapper">
        @if (!isAdditionalContent) { @if (gratitude$ | async; as gratitude) {
        <div class="content-status-page">
            <app-paragraph [text]="gratitude"></app-paragraph>
        </div>
        } @if ( !!(questionnaireService.questionnaireSubject | async)
        ?.displayScores && showScores ) {
        <div class="mt-8">
            <app-scores></app-scores>
        </div>
        } } @if (isAdditionalContent) { @if (!showScores) { @if (gratitude$ |
        async; as gratitude) {
        <div class="content-status-page">
            <app-paragraph [text]="gratitude"></app-paragraph>
            <app-video-player
                [screenId]="$safeNavigationMigration(screen?.id)"
                [videoId]="currentVideoId"
                [text]="altVideoText"
            ></app-video-player>
            <div class="mt-40">
                <div class="gap-12">
                    <span class="scores-title">Current scores</span>
                    <app-paragraph
                        [text]="
                            '\<div class=small-text>You can see your recent scores resulted from your survey by clicking \<b>‘See Scores’\</b>.\</div>'
                        "
                    ></app-paragraph>
                </div>
                <div class="inline-wrapper">
                    <app-button type="filledPrimary" (appClick)="onSubmit()">
                        See Scores
                    </app-button>
                </div>
            </div>
        </div>
        } } @if (showScores) { @if (
        !!(questionnaireService.questionnaireSubject | async) ?.displayScores &&
        showScores ) {
        <div>
            <app-scores></app-scores>
        </div>
        } } }
        <app-spinner></app-spinner>
    </div>
</div>
